import React from "react"
import Header from "../components/header"
import HeaderForNote from "./header-for-note"
import { SeminarArea } from "./seminar-area"
import BeAGoodNeighbor from "./be-a-good-neighbor"
import NoteSlide from "./note/note-slide"
import Footer from "./footer"
import Publication from "./publication"

export default function Layout({
  children,
  isNote = false,
  isSeminar = false,
  isNotFound = false
}) {
  if (isNote) {
    return (
      <>
      <Header />
      {children}
      <BeAGoodNeighbor />
      <SeminarArea />
      <Publication />
      <Footer />
      </>
    )
  } else if(isSeminar) {
    return (
      <>
      <Header />
      {children}
      <BeAGoodNeighbor />
      <NoteSlide />
      <Publication />
      <Footer />
      </>
    )
  } else if(isNotFound) {
    return (
        <>
        <Header />
        {children}
        </>
      )
  } else {
    return (
      <>
      <Header />
      {children}
      <BeAGoodNeighbor />
      <SeminarArea />
      <NoteSlide />
      <Publication />
      <Footer />
      </>
    )
  }
}
